









import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";


@Component({
  model: {
    prop: "checked",
    event: "change"
  }
})
export default class RadioButton extends Vue {
  @Prop()
  label: string;

  @Prop()
  disabled: boolean;

  @Prop([Boolean, String])
  value: boolean | string;

  @Prop()
  checked: boolean;

  @Prop()
  name: string;

  @Prop()
  validate: string;

  @Prop()
  dataVvName: string;

  @Prop()
  className: string;

  @Prop()
  id: string;

  @Prop()
  img: string;

  @Prop()
  booleanRadio: boolean;

  @Prop()
  inline: boolean;

  onChange (event) {
    if (this.booleanRadio) {
      const booleanCastValue = event.target.value === "true";
      this.$emit("change", booleanCastValue);
    } else {
      this.$emit("change", event.target.value);
    }
  }
}
